"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deriveHeaderColumns = exports.default = void 0;
const columnsMap = translate => {
  return {
    'nameOrNum': {
      label: translate('benchmarking.survey.employee.table.nameOrNum')
    },
    'specXFunc': {
      label: translate('benchmarking.survey.employee.table.specXFunc')
    },
    'employmentGrade': {
      label: translate('benchmarking.survey.employee.table.employmentGrade')
    },
    'yearOfBirth': {
      label: translate('benchmarking.survey.employee.table.yearOfBirth')
    },
    'grossSalary': {
      label: translate('benchmarking.survey.employee.table.grossSalary')
    },
    'absence': {
      label: translate('benchmarking.survey.employee.table.absence')
    },
    'orderRelatedAttendance': {
      label: translate('benchmarking.survey.employee.table.orderRelatedAttendance')
    },
    'nonOrderRelatedAttendance': {
      label: translate('benchmarking.survey.employee.table.nonOrderRelatedAttendance')
    },
    'remarks': {
      label: translate('benchmarking.survey.employee.table.remarks')
    }
  };
};
const deriveHeaderColumns = translate => {
  const columns = columnsMap(translate);
  return Object.keys(columns).map(key => {
    return {
      name: key,
      ...columns[key]
    };
  });
};
exports.deriveHeaderColumns = deriveHeaderColumns;
var _default = exports.default = deriveHeaderColumns;